import {
  createListenerMiddleware,
  type ListenerEffectAPI,
  type ListenerMiddlewareInstance,
  type ThunkDispatch,
  type UnknownAction,
} from '@reduxjs/toolkit'
import type { RootState } from '../root'
import { apiChangeListener } from './configurationRequests/apiChangeListener'
import { configurationCheckListener } from './configurationRequests/configurationCheckListener'
import { configurationCompatibilityListener } from './configurationRequests/configurationCompatibilityListener'
import { configurationCreationListener } from './configurationRequests/configurationCreationListener'
import { configurationSnapshotListener } from './configurationRequests/configurationSnapshotListener'
import { configurationStepListener } from './configurationRequests/configurationStepListener'
import { configurationTechnicalDataListener } from './configurationRequests/configurationTechnicalDataListener'
import { variantSelectionListener } from './configurationRequests/variantSelectionListener'
import { recoverConfigurationMw } from './recoverTabs'

export type ListenerDispatch = ThunkDispatch<RootState, unknown, UnknownAction>
export type AppMiddleware = ListenerMiddlewareInstance<RootState, ListenerDispatch, unknown>
export type AppListenerApi = ListenerEffectAPI<RootState, ListenerDispatch, unknown>
export const makeConfigurationRequestMiddleware = () => {
  const middleware = createListenerMiddleware<RootState>({})
  apiChangeListener(middleware)
  configurationStepListener(middleware)
  variantSelectionListener(middleware)
  configurationCheckListener(middleware)
  configurationCreationListener(middleware)
  configurationSnapshotListener(middleware)
  recoverConfigurationMw(middleware)
  configurationCompatibilityListener(middleware)
  configurationTechnicalDataListener(middleware)
  return middleware
}
